import http from './httpService';

export function getAllRiskCauses() {
  return http.get(`/risk-causes`);
}

export function createRiskCause(payload) {
  return http.post(`/risk-causes`, payload);
}

export function updateRiskCauses(payload) {
  return http.put(`/risk-causes`, payload);
}

export function deleteRiskCause(id) {
  return http.delete(`/risk-causes/${id}`);
}
